import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/skaiciuokles/atlyginimo-skaiciuokle/app/darbo-laiko-kalendorius/components/view/YearlyPageContent.tsx");
